import React from "react";
import { DateTime } from "luxon";
import "./TripAI.css";

// { zone: "utc" } matches the app-wide convention (Common.formatTimeLuxon):
// event Start/End are stored as wall-clock local time with a "Z" suffix (not
// a true UTC instant), so parsing without forcing the zone let Luxon convert
// to the VIEWER's system timezone — showing e.g. a 2pm Milan visit as 8am to
// a US-based viewer. Found 2026-10-02 via a live conflict test.
const formatTime = (iso) => {
  if (!iso) return "";
  const dt = DateTime.fromISO(iso, { zone: "utc" });
  return dt.isValid ? dt.toLocaleString(DateTime.DATETIME_MED) : String(iso);
};

// Same reasoning/props pattern as PlaceDiffCard.js. For an added/removed
// event, pass `event`, `kind`, `included`, `onToggleInclude`. For a changed
// event, pass `event` (server/new), `changedFrom` (local/old), `changedFields`
// (from GuideDiff.diffEvents), `fieldChoices`, `onFieldChoice(field, choice)`.
const EventDiffCard = ({ event, changedFrom, changedFields, itinerary, kind, included, onToggleInclude, fieldChoices, onFieldChoice }) => (
  <div className="tai-dest-card">
    <div className="tai-dest-header">
      <span className="tai-dest-title">
        {event.Subject || "(untitled event)"}
        {itinerary && itinerary !== "Main" ? ` · ${itinerary}` : ""}
      </span>
      {(kind === "added" || kind === "removed") && (
        <label className="tai-diff-include">
          <input
            type="checkbox"
            checked={included !== false}
            onChange={(e) => onToggleInclude(e.target.checked)}
          />
          {kind === "added" ? "Include their addition" : "Keep mine"}
        </label>
      )}
    </div>
    <div className="tai-row-item">
      <span className="tai-row-value">{formatTime(event.Start)}</span>
    </div>
    {changedFields && changedFields.length > 0 && (
      <>
        <div className="tai-divider" />
        {changedFields.map((field) => {
          const isTime = field === "Start" || field === "End";
          const fromVal = changedFrom?.[field];
          const toVal = event[field];
          const choice = fieldChoices?.[field];
          const radioName = `${event.Subject}-${event.Start}-${field}`;
          return (
            <div className="tai-diff-field" key={field}>
              <div className="tai-diff-field-key">{field}</div>
              <label className="tai-diff-choice">
                <input
                  type="radio"
                  name={radioName}
                  checked={choice === "mine"}
                  onChange={() => onFieldChoice(field, "mine")}
                />{" "}
                Mine: {isTime ? formatTime(fromVal) : String(fromVal ?? "")}
              </label>
              <label className="tai-diff-choice">
                <input
                  type="radio"
                  name={radioName}
                  checked={choice === "theirs"}
                  onChange={() => onFieldChoice(field, "theirs")}
                />{" "}
                Theirs: {isTime ? formatTime(toVal) : String(toVal ?? "")}
              </label>
            </div>
          );
        })}
      </>
    )}
  </div>
);

export default EventDiffCard;
